"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroSlideTypeName = void 0;
var HeroSlideTypeName;
exports.HeroSlideTypeName = HeroSlideTypeName;

(function (HeroSlideTypeName) {
  HeroSlideTypeName["TYPE_A"] = "type_a";
  HeroSlideTypeName["TYPE_B"] = "type_b";
  HeroSlideTypeName["TYPE_C"] = "type_c";
  HeroSlideTypeName["TYPE_D"] = "type_d";
})(HeroSlideTypeName || (exports.HeroSlideTypeName = HeroSlideTypeName = {}));